<template>
    <!-- Layout inner -->
    <div class="layout-inner pg_content course_about">
      <!-- Layout navbar -->
      <navbar></navbar>
      <!-- / Layout navbar -->
      <div class="layout-container">
        <div class="layout-content">

          <div class="hd_bar">
            <div class="hd_ic ic-course"></div>
            <div class="hd_txt">
              <v-clamp class="title_txt" autoresize :max-lines="2" id="courseName">{{ course.title }}</v-clamp>

              <b-popover ref="courseNamePopupContainer" target="courseName" triggers="click" placement="top" class="title_popup" container="courseNameContainer">
                <div class="title_container">
                  {{ course.title }}
                </div>
                <div class="ic_container">
                  <span class="ic ic-close" v-on:click="hideCourseNamePopup"></span>
                </div>
              </b-popover>
              <div id="courseNameContainer" class="title_container_popup"></div>
            </div>
          </div>

          <!-- Page content -->
          <div class="container-fluid flex-grow-1 pg_content_container">

            <div class="row">
              <div class="col-sm-12 col-xl-12 pg_sec sec_course_info">

                <div v-if="course.thumbnail" class="d-flex align-items-center justify-content-center">
    						    <img class="w-100" v-bind:src="course.thumbnail" alt="Img">
    	        	</div>

                <div class="pg_content_row">
                  <span class="content_label"># of {{creditLabel}}s : </span>
                  <span class="content_value">{{course.maxCredit}}</span>
                </div>

                <div class="pg_content_row">
                  <div class="description">
                    {{course.description}}
                  </div>
                </div>

                <div class="row_separator"></div>

                <div class="pg_content_row">
                  <span class="content_label">Instructor : </span>
                  <span class="content_value">{{instructorName}}</span>
                </div>

              </div>

            </div>
          </div>
          <!-- / Page content -->
          <!-- Footer Navbar -->
          <template>
            <course-footer-navbar :uuid="uuid" :isCourseFinished="true"></course-footer-navbar>
          </template>
          <!-- / Footer Navbar -->
        </div>
      </div>
    </div>
    <!-- Layout inner -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import SecondaryNavbar from '../../misc/components/./SecondaryNavbar'
import CourseFooterNavbar from '../../misc/components/./CourseFooterNavbar'
import TOC from './TOC'
import VClamp from 'vue-clamp'
import { PACKAGE } from '../../../package_constants'

export default {
  name: 'courseDetail',
  props: ['uuid', 'entityUuid'],
  components: {
    Navbar,
    SecondaryNavbar,
    CourseFooterNavbar,
    VClamp,
    TOC
  },
  data: () => {
    return {
      course: {},
      competencySummary: {},
      continueLearningOptions: [],
      idealPaceVal: '',
      classPaceVal: '',
      userPaceVal: '',
      pace: {}
    }
  },

  mounted () {
    this.loadCourseInfo()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadContinueLearningLast',
      'loadClassSummaryWithPeer',
      'loadCompetencyProgress',
      'loadUserObj'
    ]),
    async loadCourseInfo () {
      this.course = await this.loadCourseDetail(this.uuid)
      this.continueLearningOptions = await this.loadContinueLearningLast(this.uuid)
      await this.loadUserObj()
    },
    hideCourseNamePopup () {
      this.$refs.courseNamePopupContainer.$emit('close')
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'enabledFeatures': state => state.dashboard.enabledFeatures
    }),
    creditLabel () {
      let creditLabelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CUSTOM_CREDIT_LABEL_FEATURE_ID]
      if (!creditLabelFeature || !creditLabelFeature.enabled || !creditLabelFeature.label) {
        return 'Credit'
      }
      return creditLabelFeature.label
    },
    userName () {
      if (this.userObj) {
        return this.userObj.firstName + ' ' + this.userObj.lastName
      } else {
        return ''
      }
    },
    major () {
      if (this.userObj) {
        return this.userObj.major1Title
      } else {
        return ''
      }
    },
    majorGPA () {
      if (this.userObj) {
        return this.userObj.majorGpa
      } else {
        return '0.0'
      }
    },
    overallGPA () {
      if (this.userObj) {
        return this.userObj.overallGpa
      } else {
        return '0.0'
      }
    },
    isCourseFinished () {
      let isFinished = true
      if (this.continueLearningOptions.length > 0 && (this.continueLearningOptions[0].title !== 'COURSE_FINISHED')) {
        isFinished = false
      }
      return isFinished
    },
    instructorName () {
      if (this.course.instructorNames) {
        var str = this.course.instructorNames[0]
        var res = str.split('__')
        var instNames = res[0]
        for (var i = 1; i < this.course.instructorNames.length; i++) {
          str = this.course.instructorNames[i]
          res = str.split('__')
          instNames = instNames + ', ' + res[0]
        }
        return instNames
      } else {
        return ''
      }
    }
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/CourseDetail.vue